import React from 'react';
import {
  CatCard,
  CatGrid,
  CatGridItem,
  CatHeading
} from 'components/blocks-components';
import { PurifiedHtml } from 'components/purified-html';
import ViewButton from './view-button';
import ScrollToTop from 'app/[lang]/[esite]/(core)/account/(with-nav)/control-center/common/scroll-to-top';
import { getPartsDetails } from 'services/parts-diagram/actions';
import useURLParams from 'hooks/useURLParams';
import styles from './parts-card.module.scss';
import { usePartDiagram } from 'hooks/use-part-diagram/parts-diagram-context';
import { CATEGORY_TYPES, GroupPartsType } from 'types/parts-diagram';

const PartsCard = () => {
  const { componentsData, handlePartsContentCategory, handleSelectedPart } =
    usePartDiagram();
  const { setParamsWithWindows } = useURLParams();

  const handleCardViewButton = async (groupItem: GroupPartsType) => {
    handlePartsContentCategory(CATEGORY_TYPES.LOADER);
    const { ieSystemControlNumber = '', partNumber = '' } = groupItem || {};
    setParamsWithWindows(
      'ieSystemControlNumber',
      groupItem.ieSystemControlNumber
    );
    const { partDetailsAndSchematicResponse } = await getPartsDetails(
      ieSystemControlNumber
    );
    handlePartsContentCategory(
      CATEGORY_TYPES.PARTSDETAILS,
      null,
      partDetailsAndSchematicResponse
    );
    handleSelectedPart({ partNumber, ieSystemControlNumber });
  };

  const returnCard = (cardsData: GroupPartsType[]) => {
    return cardsData?.map((item, index) => {
      const {
        partNumber = '',
        ieSystemControlNumber = '',
        captionName = ''
      } = item || {};
      return (
        <CatGridItem key={`${partNumber}_${ieSystemControlNumber}`}>
          <ScrollToTop data={componentsData} />
          <CatCard removePadding={true}>
            <div className="cat-u-padding-md d-flex flex-column justify-content-between h-100">
              <CatHeading
                level="h3"
                variant="title-sm"
                data-testId={`card${index}`}
                className={styles['cardText']}
              >
                <PurifiedHtml htmlString={captionName} />
              </CatHeading>

              <ViewButton
                handleCardViewButton={() => handleCardViewButton(item)}
              />
            </div>
          </CatCard>
        </CatGridItem>
      );
    });
  };

  return (
    <>
      {componentsData?.groupParts?.length > 0 && (
        <>
          <div className="cat-u-padding-bottom-md">
            <CatHeading
              variant="title"
              data-testId={`component_header`}
              className="cat-u-padding-bottom-md"
            >
              {componentsData?.description}
            </CatHeading>
          </div>
          <CatGrid className="d-sm-block d-lg-none" variant="side-by-side">
            {returnCard(componentsData.groupParts)}
          </CatGrid>
          <CatGrid className="d-none d-lg-inline" variant="4up">
            {returnCard(componentsData.groupParts)}
          </CatGrid>
        </>
      )}
    </>
  );
};

export default PartsCard;
